import { Page, View, Image, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import bgImage from '@assets/images/bg_speakers.png';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import { useTranslation } from 'react-i18next';

export interface ColocatedEventsProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  portfolios: ResponsePaginationType<Portfolio> | undefined;
  header: JSX.Element;
  footer: JSX.Element;
}

const ColocatedEvents = ({
  event,
  coLocatedEvents,
  portfolios,
  header,
  footer,
}: ColocatedEventsProps) => {
  const { t } = useTranslation();

  const homeEventLink = '';

  const renderListTitle = () => {
    const maximizeText = t('partner-maximize-reach', {
      eventName: event?.name,
    });
    if (coLocatedEvents?.length === 0) return maximizeText;
    if (coLocatedEvents?.length === 1)
      return `${t('event-the')} ${coLocatedEvents[0].name}`;

    return `${maximizeText}${(coLocatedEvents ?? [])
      .map((event, index) =>
        index === (coLocatedEvents ?? []).length - 1
          ? ` ${t('event-and-the')} ${event.name}`
          : `, ${t('event-the')} ${event.name}`
      )
      .join('')}.`;
  };

  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      <View style={styles.backgroundContainer}>
        <Image
          src={
            'https://media.we-conect.com/images/pdf/agenda/pdf_agenda_colocated.jpg'
          }
          style={styles.backgroundImage}
        />

        <View>{header}</View>

        <View style={styles.overlayContent}>
          <Text style={styles.title}>{t('co-located-page-title-part-1')}</Text>
          <Text style={styles.title}>
            {t('co-located-page-title-part-2', {
              numberOfColocatedEvents: coLocatedEvents?.length ?? 1,
            })}
          </Text>
          <View
            style={{
              ...styles.lineBar,
            }}
          ></View>
        </View>
      </View>

      <View
        style={{
          ...styles.contentWrapper,
        }}
      >
        <Text style={styles.listTitle}>{renderListTitle()}</Text>

        {[1, 2, 3, 4, 5].map(index => {
          return (
            <View
              key={`increase-your-sales-item-${index}`}
              style={styles.itemWrapper}
            >
              <Text style={styles.bulletItem}>
                {'\u2022'} {t(`co-located-page-list-item-${index}`)}
              </Text>
            </View>
          );
        })}

        <View style={styles.inlineTextWrapper}>
          <Text>
            <Text style={styles.listSubParagraphBold}>
              {t('co-located-page-list-subparagraph-bold')}{' '}
            </Text>
            <Text style={styles.listSubParagraph}>
              {t('co-located-page-list-subparagraph')}
            </Text>
          </Text>
        </View>

        <View style={styles.buttonWrapper}>
          <Link
            style={{
              ...styles.button,
              backgroundColor: event?.design?.themeColor,
            }}
            src={homeEventLink}
          >
            {t('book-partner-package-now')}
          </Link>
        </View>
      </View>

      <View style={styles.testimonialsWrapper}>
        {[1, 2, 3].map(index => (
          <View key={index} style={styles.testimonialBox}>
            <Text style={styles.testimonialCitation}>
              {'"'}
              {t(`co-located-page-testimonial-list-item-citation-${index}`)}
              {'"'}
            </Text>
            <Text style={styles.testimonialSpeaker}>
              {t(`co-located-page-testimonial-list-item-speaker-info-${index}`)}
            </Text>
          </View>
        ))}
      </View>

      {footer}
    </Page>
  );
};

export default ColocatedEvents;
